import http from '../lib/http';

export const FETCH_DAILY_REPORT_SUM_START = 'FETCH_DAILY_REPORT_SUM_START';
export const FETCH_DAILY_REPORT_SUM_ERROR = 'FETCH_DAILY_REPORT_SUM_ERROR';
export const FETCH_DAILY_REPORT_SUM_SUCCESS = 'FETCH_DAILY_REPORT_SUM_SUCCESS';

export const FETCH_IS_BAR_REPORT_OPEN_START = 'FETCH_IS_BAR_REPORT_OPEN_START';
export const FETCH_IS_BAR_REPORT_OPEN_ERROR = 'FETCH_IS_BAR_REPORT_OPEN_ERROR';
export const FETCH_IS_BAR_REPORT_OPEN_SUCCESS = 'FETCH_IS_BAR_REPORT_OPEN_SUCCESS';

export const FETCH_IS_BAR_REPORT_OPEN_2_START = 'FETCH_IS_BAR_REPORT_OPEN_2_START';
export const FETCH_IS_BAR_REPORT_OPEN_2_ERROR = 'FETCH_IS_BAR_REPORT_OPEN_2_ERROR';
export const FETCH_IS_BAR_REPORT_OPEN_2_SUCCESS = 'FETCH_IS_BAR_REPORT_OPEN_2_SUCCESS';

export const FETCH_IS_BILL_OUT_OF_REPORT_START = 'FETCH_IS_BILL_OUT_OF_REPORT_START';
export const FETCH_IS_BILL_OUT_OF_REPORT_ERROR = 'FETCH_IS_BILL_OUT_OF_REPORT_ERROR';
export const FETCH_IS_BILL_OUT_OF_REPORT_SUCCESS = 'FETCH_IS_BILL_OUT_OF_REPORT_SUCCESS';

export const OPEN_BAR_REPORT_START = 'OPEN_BAR_REPORT_START';
export const OPEN_BAR_REPORT_ERROR = 'OPEN_BAR_REPORT_ERROR';
export const OPEN_BAR_REPORT_SUCCESS = 'OPEN_BAR_REPORT_SUCCESS';

export const CLOSE_BAR_REPORT_START = 'CLOSE_BAR_REPORT_START';
export const CLOSE_BAR_REPORT_ERROR = 'CLOSE_BAR_REPORT_ERROR';
export const CLOSE_BAR_REPORT_SUCCESS = 'CLOSE_BAR_REPORT_SUCCESS';

export const CLOSE_PRINT_DAILY_SUM = 'CLOSE_PRINT_DAILY_SUM';
export const SET_REPORT_IS_OPEN = 'SET_REPORT_IS_OPEN';
export const OPEN_CLOSE_REPORT_PANEL = 'OPEN_CLOSE_REPORT_PANEL';
export const CLOSE_CLOSE_REPORT_PANEL = 'CLOSE_CLOSE_REPORT_PANEL';

export function setReportIsOpen(open) {
    return {
        type: SET_REPORT_IS_OPEN,
        payload: {open}
    }
}

export function closeCloseReportPanel() {
    return {
        type: CLOSE_CLOSE_REPORT_PANEL
    }
}

export function openCloseReportPanel() {
    return {
        type: OPEN_CLOSE_REPORT_PANEL
    }
}

export function closePrintDailySum() {
    return {
        type: CLOSE_PRINT_DAILY_SUM
    }
}

export function closeBarReport(barId) {
    return {
        type: 'CLOSE_BAR_REPORT',
        payload: {
            promise: postCloseBarReport(barId)
        }
    };
}

export function openBarReport(barId, dayName) {
    return {
        type: 'OPEN_BAR_REPORT',
        payload: {
            promise: postOpenBarReport(barId, dayName)
        }
    };
}

export function fetchDailyReportSum(barId) {
    return {
        type: 'FETCH_DAILY_REPORT_SUM',
        payload: {
            promise: getDailyReportSum(barId)
        }
    };
}

export function fetchIsBarReportOpen2(barId) {
    return {
        type: 'FETCH_IS_BAR_REPORT_OPEN_2',
        payload: {
            promise: getIsBarReportOpen(barId)
        }
    };
}

export function fetchIsBarReportOpen(barId) {
    return {
        type: 'FETCH_IS_BAR_REPORT_OPEN',
        payload: {
            promise: getIsBarReportOpen(barId)
        }
    };
}

export function isBillOutOfReport(barId) {
    return {
        type: 'FETCH_IS_BILL_OUT_OF_REPORT',
        payload: {
            promise: getIsBillOutOfReport(barId)
        }
    };
}

async function getDailyReportSum(barId) {
    const res = await http.get(`/app/bar/sale/${barId}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function getIsBillOutOfReport(barId) {
    const res = await http.get(`/app/is-is-bill-out-of-report/${barId}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function getIsBarReportOpen(barId) {
    const res = await http.get(`/app/is-bar-open/${barId}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function postOpenBarReport(barId, dayName) {
    const res = await http.post(`/app/open-report/${barId}`, {body: dayName});
    if (res.status < 300) return res.json();
    throw res;
}

async function postCloseBarReport(barId) {
    const res = await http.post(`/app/close-report/${barId}`, {body: ""});
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/report/actions.js